import { render, staticRenderFns } from "./WithDrawLimitReason.vue?vue&type=template&id=079a7992&scoped=true&"
import script from "./WithDrawLimitReason.vue?vue&type=script&lang=js&"
export * from "./WithDrawLimitReason.vue?vue&type=script&lang=js&"
import style0 from "./WithDrawLimitReason.vue?vue&type=style&index=0&id=079a7992&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079a7992",
  null
  
)

export default component.exports